export default __webpack_public_path__ + "static/media/37.fc83b442.jpg";